import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  BookingCategoryType,
  WidgetTabsComponent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import { AnalyticsDataPopulateService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { BookingTabFacadeService } from '../../../data-access/facades/booking-tab/booking-tab-facade.service';

@Component({
  selector: 'idp-booking-tab',
  standalone: true,
  imports: [CommonModule, WidgetTabsComponent, PushPipe],
  templateUrl: './booking-tab.component.html',
  styleUrls: ['./booking-tab.component.scss']
})
export class BookingTabComponent implements OnChanges {
  @Output() tabSelectEmit = new EventEmitter<BookingCategoryType>();
  @Input() selectedIndex = 0;

  bookingTabFacade = inject(BookingTabFacadeService);
  analyticsService = inject(AnalyticsDataPopulateService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['selectedIndex']) {
        this.bookingTabFacade.init(changes['selectedIndex'].currentValue ?? 0);
      }
    }
  }

  externalLinkClicked(link: string): void {
    if (link) {
      window.open(link, '_blank');
    }
  }

  tabSelectClicked(tab: BookingCategoryType): void {
    this.tabSelectEmit.emit(tab);
  }

  onExternalLinkTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }

  onTabClickTracking(category: BookingCategoryType): void {
    const mockElement = document.createElement('button');
    mockElement.setAttribute('data-acdl-name', category);
    mockElement.setAttribute(
      'data-acdl-action',
      `widget:${category} tab click`
    );
    mockElement.setAttribute(
      'data-acdl-page-section',
      `header:book:${category}`
    );
    mockElement.setAttribute('data-booking-tab', 'true');
    this.analyticsService.populateAnalyticsData(mockElement);
  }

  handleAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }
}
